import { create } from "zustand";
import { InitializePaginationProperties, InitializeSetPaginationProperties, PaginationProperties, SetPaginationProperties } from "../../../../../common/utils/pagination_property";

/**
 * useCadastroCoresListaPagination
 */

type State = PaginationProperties;

type Actions = SetPaginationProperties;

export const useCadastroCoresListaPagination = create<State & Actions>((set) => ({
  ...InitializePaginationProperties(),
  ...InitializeSetPaginationProperties(set),
}));